import React from 'react'
import './Main.css';
import ReceiptHtml from './components/ReceiptHtml';
import domtoimage from 'dom-to-image';

const QUALITY_SCALE = 2;
const WIDTH_SCALE = 1.3;

function Main() {
  const playSoundUrls = async () => {
    if (!!window.ReactNativeWebView) {
      const messageToIOS = JSON.stringify({
        "type": "PLAY_SOUND",
        "soundUrls": ['https://samsung-tko.lemondice.com/audios/ding.wav', 'https://samsung-tko.lemondice.com/audios/A.wav', 'https://samsung-tko.lemondice.com/audios/0.wav', 'https://samsung-tko.lemondice.com/audios/1.wav']
      });
      window.ReactNativeWebView.postMessage(messageToIOS);
    } else {
      alert('no react native webview injection found')
    }
  }
  const printReceipt = async () => {
    const node = document.getElementById('receipt')
    const dataUrl = await domtoimage.toJpeg(node, {
      width: node.clientWidth * QUALITY_SCALE,
      height: node.clientHeight * QUALITY_SCALE,
      style: {
        transform: 'scale(' + QUALITY_SCALE + ')',
        transformOrigin: 'top left'
      }})

    /* Check base64Image qauality in browser */
    // var img = new Image();
    // img.src = dataUrl;
    // document.body.appendChild(img);
    
    if (!!window.ReactNativeWebView) {
      const messageToIOS = JSON.stringify({
        "type": "PRINT",
        "base64Image": dataUrl,
        "width": node.offsetWidth * WIDTH_SCALE // 576 dots (w?) fot TSP100III
      });

      window.ReactNativeWebView.postMessage(messageToIOS);
    } else {
      alert('no react native webview injection found')
    }
  }
  return <div className="p-10 flex flex-col justify-center items-center mt-10 mx-auto">
    <ReceiptHtml />
    <button
      type="button"
      onClick={printReceipt}
      className="mt-20 max-w-xl rounded-sm bg-blue-100 px-6 py-4 text-3xl font-semibold text-gray-500 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50"
    >
      列印測試
    </button>
    <button
      type="button"
      onClick={playSoundUrls}
      className="my-10 max-w-xl rounded-sm bg-blue-100 px-6 py-4 text-3xl font-semibold text-gray-500 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50"
    >
      聲音測試
    </button>
  </div>
}

export default Main;
